import AutoGrowTextarea from '../AutoGrowTextarea';

export default function InputNode({ id, data }) {
    const inputPrompt = data?.inputPrompt || '';
    const inputVar = data?.inputVar || '';
    const inputType = data?.inputType || 'text';
    const inputTimeout = data?.inputTimeout ?? 60;

    return (
        <div className="mt-2 space-y-2">
            <AutoGrowTextarea className="spt-textarea border-2" placeholder="Pergunta para o usuário"
                value={inputPrompt}
                onChange={(e) => data?.onChangeInput?.(id, { inputPrompt: e.target.value })} />

            <div className="flex items-center gap-2">
                <span className="text-[9px] text-gray-400 shrink-0">Salvar em:</span>
                <input type="text" className="input3 flex-1 font-mono" placeholder="nome_variavel"
                    value={inputVar}
                    onChange={(e) => data?.onChangeInput?.(id, { inputVar: e.target.value })} />
                <span className="text-[9px] text-gray-500 shrink-0">{'{ }'}</span>
            </div>

            <div className="block mt-2">
                <select className="form-select w-full" value={inputType}
                    onChange={(e) => data?.onChangeInput?.(id, { inputType: e.target.value })}>
                    <option value="text">Texto</option>
                    <option value="number">Número</option>
                    <option value="email">E-mail</option>
                    <option value="phone">Telefone</option>
                </select>
                <div className="flex items-center gap-1 mt-2">
                    <i className="fas fa-clock text-sky-400 text-[10px]" /> Timeout
                    <input type="number" min="5" step="1" className="input3 flex-1" placeholder="60"
                        value={inputTimeout}
                        onChange={(e) => data?.onChangeInput?.(id, { inputTimeout: e.target.value })} />
                    <span className="text-[9px] text-gray-400">segundos</span>
                </div>
            </div>

            <div className="flex items-center gap-1.5 mt-1">
                <div className="h-px flex-1 bg-sky-500/30" />
                <span className="text-[9px] font-semibold text-sky-400 uppercase tracking-wider">Saídas</span>
                <div className="h-px flex-1 bg-sky-500/30" />
            </div>
            <div className="flex justify-between text-[9px] font-semibold px-1 pb-1">
                <span className="text-red-400">⏰ Timeout</span>
                <span className="text-emerald-400">✅ OK</span>
            </div>
        </div>
    );
}
